import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { WhatsAppNotifyButton } from "@/components/WhatsAppNotifyButton";
import { api, fmtDate } from "@/lib/api";

const PICKUP = "Disponível para retirada";

export function StoreNotify({ order }) {
  const { user } = useAuth();
  const [template, setTemplate] = useState(null);
  const [notifiedAt, setNotifiedAt] = useState(order.notified_at);
  const show = user?.role === "store" && order.status === PICKUP;

  useEffect(() => {
    if (show) api.get("/store/pickup-message").then((r) => setTemplate(r.data.pickup_message)).catch(() => {});
  }, [show]);

  if (!show || !template) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-green-200 bg-green-50 p-4" data-testid="store-notify-box">
      <p className="text-sm font-semibold text-green-900" data-testid="store-notified-info">
        {notifiedAt ? `Cliente avisado em ${fmtDate(notifiedAt)}` : "Pedido pronto! Avise o cliente sobre a retirada."}
      </p>
      <WhatsAppNotifyButton order={{ ...order, notified_at: notifiedAt }} template={template} basePath="/store"
        onNotified={(o) => setNotifiedAt(o.notified_at)} testId="btn-store-whatsapp-notify" />
    </div>
  );
}
